import type { Item } from '@shared/types-v0.1.0';
// import type { HistoryItem } from './fetch'

type RefItem = Item & { [dbClass: string]: { id: string } };

//
export default (rawItem: Item) => {
	const prototype = Object.create(
		{
			// ==Описываем функции для proxy object
			// Возвращает item из указанного класса, на который ссылается данный proxy object
			getRef: (dbClass: string) => {
				const globalItem = R.items[rawItem.id];
				if (globalItem?.[dbClass]) {
					if (Array.isArray(globalItem[dbClass])) return globalItem[dbClass].map((i) => R.items[i.id]).filter((i) => !!i);
					return R.items[globalItem[dbClass].id];
				}
				return undefined;
			},
			// Возвращает item из указанного класса, который ссылается на данный proxy object
			getBackRef: (dbClass: string) => {
				let resultRefItem: Item | undefined;
				R.libs.just.map(R.items as any, (_, refItem: RefItem) => {
					if (refItem.dbClass === dbClass && refItem[rawItem.dbClass]?.id === rawItem.id) resultRefItem = refItem;
				});
				return resultRefItem;
			},
			// getHistory: (count?: number) => {
			// 	const snapshot = R.libs.valtio.snapshot
			// 	const take = R.libs.remeda.take
			//
			// 	return R.itemsHistory[rawItem.id]
			// 		? count
			// 			? (take(snapshot(R.itemsHistory[rawItem.id]), count) as HistoryItem[])
			// 			: (snapshot(R.itemsHistory[rawItem.id]) as HistoryItem[])
			// 		: []
			// },
			// Возвращает states, заданные для данного класса из kuzzle - dbClass_v2
			getDbClassState: (statePath: string) => R.libs.just.get(R.dbClasses, `${rawItem.dbClass}.states.${statePath}`),
		},
		// Для id и dbClass мы явно указываем "особый режим":
		// - Нельзя изменить (writable: false)
		// - Нельзя удалить (configurable: false)
		// - Можно увидеть при перечислении (enumerable: true)

		// А все остальные свойства, которые копируются через Object.assign(), получают дефолтные настройки:
		// - writable: true (можно изменять)
		// - configurable: true (можно удалять)
		// - enumerable: true (видны при перечислении)
		{
			id: { enumerable: true, writable: false, configurable: false, value: rawItem.id },
			dbClass: { enumerable: true, writable: false, configurable: false, value: rawItem.dbClass },
		}
	);

	return Object.assign(prototype, R.libs.just.omit(rawItem, ['id', 'dbClass']));
};
